"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var symbols = {
    BRL: ["R$", "BRL"],
    RON: ["lei", "LEI", "Lei", "RON"],
    USD: ["$", "US$", "US dollars", "USD"],
    GBP: ["£", "GBP"],
    EUR: ["€", "Euro", "EUR"],
    RUB: ["руб", "RUB"],
    ILS: ["₪", "ILS"],
};
var parseMoney = function (text) {
    var output = null;
    var currenciesFound = [];
    Object.keys(symbols).forEach(function (currency) {
        symbols[currency].find(function (symbol) {
            var index = text.indexOf(symbol);
            if (index > -1) {
                currenciesFound.push({ currency: currency, index: index });
            }
        });
    });
    var index = 0;
    var currency = null;
    if (currenciesFound.length >= 1) {
        currency = currenciesFound[0].currency;
        index = currenciesFound[0].index;
    }
    var start = Math.max(0, index - 40);
    var end = index + 40;
    var slice = text.substr(start, end);
    slice = slice.replace(/[^\d|^\.|^,]/g, "");
    slice = slice.replace(/(,|\.)*$/, "");
    while (slice.charAt(0) === "." || slice.charAt(0) === ",") {
        slice = slice.substr(1);
    }
    if (!slice.length)
        return null;
    var dotCount = slice.split(".").length - 1;
    var commaCount = slice.split(",").length - 1;
    var amount = 0;
    if (dotCount === 0 && commaCount === 0) {
    }
    else if (commaCount > 1 && dotCount <= 1) {
        slice = slice.split(",").join("");
    }
    else if (dotCount > 1 && commaCount <= 1) {
        slice = slice.split(".").join("");
        slice = slice.split(",").join(".");
    }
    else if (dotCount > 0 && commaCount > 0) {
        if (slice.indexOf(".") > slice.indexOf(",")) {
            slice = slice.split(",").join("");
        }
        else {
            slice = slice.split(".").join("");
            slice = slice.split(",").join(".");
        }
    }
    else if (dotCount === 1 && commaCount === 0) {
        var segments = slice.split(".");
        var second = segments[1];
        if (second.length === 3) {
            slice = slice.replace(".", "");
        }
        else {
        }
    }
    else {
        var segments = slice.split(",");
        var second = segments[1];
        if (second.length === 3) {
            slice = slice.replace(",", "");
        }
        else {
            slice = slice.replace(",", ".");
        }
    }
    amount = parseFloat(slice);
    output = {
        amount: amount,
        currency: currency,
    };
    return output;
};
exports.default = parseMoney;
//# sourceMappingURL=index.js.map